import React, {useMemo, useRef, createContext} from "react"
import ReactModal from "react-modal"
import {useOnMount} from 'js/studios/shared/unredux/hooks'
import {classNames} from 'js/studios/shared/utils'
import {ErrorBoundary} from 'js/studios/shared/error_boundary'

export class Modal extends React.Component {
  componentDidMount() {
    ReactModal.setAppElement('body')
  }

  render() {
    let closeButton = null
    if (this.props.closeButton === true) {
      closeButton = <a className="icon-cancel cancel" onClick={this.props.onRequestClose}></a>
    }

    return <ErrorBoundary>
      <ReactModal
        isOpen={this.props.isOpen}
        onAfterOpen={this.props.onAfterOpen}
        onRequestClose={this.props.onRequestClose}
        closeTimeoutMS={300}
        overlayClassName={classNames('dialog_full modal_bg_new', {open: this.props.isOpen, [this.props.overlayClassName]: this.props.overlayClassName})}
        contentLabel={this.props.contentLabel}
        className={classNames('modal_container', {[this.props.className]: this.props.className})}
        shouldCloseOnOverlayClick={this.props.shouldCloseOnOverlayClick}
      >
        {closeButton}
        {this.props.children}
      </ReactModal>
    </ErrorBoundary>
  }
}

// a slightly tweaked modal approach for brand2025 consumer-facing apps
export function ConsumerModal({
  isOpen,
  onAfterOpen,
  onRequestClose,
  className,
  contentLabel,
  shouldCloseOnOverlayClick=true,
  overlayClassName="",
  closeTimeoutMS=120, // must match the transition-duration on the overlay, if you override you must specify an overlayClassName and write css to match
  children,
}) {
  useOnMount(() => ReactModal.setAppElement('body'))

  return <ErrorBoundary>
    <ReactModal
      isOpen={isOpen}
      onAfterOpen={onAfterOpen}
      onRequestClose={onRequestClose}
      closeTimeoutMS={closeTimeoutMS}
      overlayClassName={overlayClassName} // empty-string default prevents default `style=` attrs from react-modal which would override our css
      className={classNames("ReactModal__content--cm", className)}
      contentLabel={contentLabel}
      style={{overlay: {backgroundColor: undefined}}}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
    >
      {children}
      <button className="ReactModal__close btn btn--icon btn--sm" type="button" aria-label="Close modal" tabIndex="0" onClick={onRequestClose}>
        <span className="icon icon--x"></span>
      </button>
    </ReactModal>
  </ErrorBoundary>
}

const ScrollModalCtx = createContext(null)
ScrollModalCtx.displayName = "ScrollModalCtx"

// use this component as the first child of a ConsumerModal when contents may be too long and
// require scrolling. Provides a context with access to the scroll container div so modals
// can manually manage scrolling as needed.
export function ModalScrollContent({children}) {
  const
    scrollDivRef = useRef(),
    ctxVal = useMemo(() => ({
      scrollDivRef: scrollDivRef,
      scrollToBottom: () => scrollDivRef.current?.scrollTo?.(
        {top: scrollDivRef.current?.scrollHeight, behavior: "smooth"}
      ),
    }), [])

  return <div className="modal-scroll-content">
    <div ref={scrollDivRef}>
      <ScrollModalCtx.Provider value={ctxVal}>{children}</ScrollModalCtx.Provider>
    </div>
  </div>
}
ModalScrollContent.Ctx = ScrollModalCtx
